import React from "react";
import "./HowWorks.css";

const steps = [
  {
    number: "1",
    title: "האזור האישי שלכם",
    description:
      "איזה כיף! השלב הכי מרגש בתהליך שלנו. בשלב זה תיצרו לחברה, לעסק או לארגון שלכם משתמש אצלנו. מאחורי הקלעים המערכת שלנו תקים לכם אזור אישי מותאם במיוחד עבורכם.",
  },
  {
    number: "2",
    title: "למידת המערכת",
    description:
      "פנו לכם חצי שעה, תכינו לכם כוס קפה ועוגה ולימדו את המערכת, עברו על דברים חשובים ותתחילו להכיר את גמבוט. כמובן בשלב זה הצוות שלנו עומד לרשותכם ויענה על כל שאלה בווצאפ וגם בשיחת טלפון עם נציג אנושי.",
  },
  {
    number: "3",
    title: "סנכרון לקוחות",
    description:
      "בעזרת קובץ אקסל של גמבוט עם טמפלייט מוכן מראש, תעלו למערכת את אנשי הקשר שלכם ותראו אותם תוך רגע מסודרים באזור האישי.",
  },
  {
    number: "4",
    title: "יצירת הגמבוט שלכם",
    description:
      "בשלב זה, אתם תגדירו תבניות מותאמות אישית עם משתנים שונים לצרכי העסק שלכם. בנוסף, תיצרו אוטומציות שיענו ללקוחות שלכם באופן מיידי ומדויק, או תרחיבו אותן עם AI שידבר ישירות עם הלקוחות בשמכם.",
  },
  {
    number: "5",
    title: "אתם הולכים לים וגמבוט עובד בשבילכם",
    description:
      "בשלב זה, גמבוט יעבוד עבורכם מאחורי הקלעים וינהל לכם את ממשק התקשורת בווצאפ עם הלקוחות שלכם.",
  },
];

const HowWorks = () => {
  return (
    <div className="how-works">
      <h2 className="how-works__title">
        איך זה <span className="highlight">עובד?</span>
      </h2>

      <div className="how-works__steps">
        {steps.map((step) => (
          <div className="how-works__card" key={step.number}>
            <div className="how-works__number">{step.number}</div>
            <h3 className="how-works__card-title">{step.title}</h3>
            <p className="how-works__description">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowWorks;
